import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import BaseForm from 'components/atoms/base-form';
import BaseFormItem from 'components/atoms/base-form/item';
import BaseTextArea from 'components/atoms/base-textarea';
import BaseSelectBox from 'components/atoms/base-select-box';
import { TRACKING_PLATFORM_OPTIONS } from 'infrastructure/hooks/patient/use-tracking-platform';

import { medicalHistoryValidationSchema } from './validation-schema';

import type { FormikHelpers } from 'formik';
import type { Values } from './validation-schema';
import type { IUpdateMedicalHistory } from 'infrastructure/interfaces';
import type { FC } from 'react';

interface MedicalHistoryFormProps {
  onCancelForm: () => void;
  onSubmit: (values: Values, formikHelpers: FormikHelpers<Values>) => void;
  loading: boolean;
  defaultValues?: Omit<IUpdateMedicalHistory, 'patientGuid'>;
  showTrackingPlatform?: boolean;
}

const MedicalHistoryForm: FC<MedicalHistoryFormProps> = ({
  loading,
  onCancelForm,
  onSubmit,
  defaultValues,
  showTrackingPlatform,
}) => {
  const { t } = useTranslation();
  const formik = useFormik<Values>({
    initialValues:
      medicalHistoryValidationSchema(showTrackingPlatform).cast(defaultValues),
    enableReinitialize: true,
    onSubmit,
    validateOnChange: true,
    validationSchema: medicalHistoryValidationSchema(showTrackingPlatform),
  });

  const { submitForm, resetForm } = formik;

  const onCancel = () => {
    resetForm();
    onCancelForm();
  };
  return (
    <BaseForm
      formik={formik}
      withControls
      plaintext={false}
      readonly={false}
      onSave={submitForm}
      onCancel={onCancel}
      loading={loading}
    >
      {showTrackingPlatform && (
        <BaseFormItem
          name="trackingPlatform"
          label={t('labels.program')}
          required
          isBlackLabel
        >
          <BaseSelectBox
            options={TRACKING_PLATFORM_OPTIONS}
            placeholder={t('labels.selectProgram')}
          />
        </BaseFormItem>
      )}
      <BaseFormItem name="record">
        <BaseTextArea rows={10} />
      </BaseFormItem>
    </BaseForm>
  );
};
export default MedicalHistoryForm;
